<template>
  <div>
    Logging out: please wait...
  </div>
</template>
<script>
import env from 'environment';

import UserService from 'vue-core/services/UserService';

export default {
  name: 'Logout',

  data() {
    return {
      loggedOut: false,
      error: null
    };
  },

  watch: {
    '$route': 'logout'
  },

  created () {
    this.logout()
  },

  methods: {
    logout() {
      let redirect = '/public';

      const success = ({ statusCode, data }) => {
        console.log('Logout success. Routing to ' + redirect);
        this.$router.push({ path: redirect });
      };

      const error = ({ statusCode, data }) => {
        console.log('Error', statusCode, data);
        switch (statusCode) {
          case 0:
            this.error = 'Server probably down.';
            break;
          default:
            this.error = 'Generic error. Please, contact the server administrator.';
        }
      };

      this.error = null;

      UserService.logout().then(success, error);
    }
  }
}
</script>
